/* eslint-disable react/prop-types */
import React, { Fragment } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Modal,
  Container,
  CardText,
} from "reactstrap"
import { ModalTable } from "./ModalTable"
export const LargeModal = props => {

  const {
    data,
    columns,
    isOpen,
    size,
    setIsOpen,
    TicketNumber,
    cardsData,
    EcommerceOrderColumns,
    betType,
  } = props
  return (
      <Fragment>
        <div>
          <Modal
              size={size}
              isOpen={isOpen}
              centered
              //   toggle={() => {
              //     tog_xlarge()
              //   }}
          >
            <div
                className="modal-header"
                style={{ backgroundColor: "#f5f5f5", color: "black" }}
            >
              <h5 className="modal-title mt-0" id="myExtraLargeModalLabel">
                Ticket {data?.id}
              </h5>
              <button
                  onClick={() => {
                    setIsOpen(false)
                  }}
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">

              {/* ---------------------- Table end -------------------------- */}
              <Row>
                {cardsData.map(card => {
                  return (
                      <>
                        <Col lg={3}>
                          <Card
                              color={card.color}
                              className={`text-white-50 ${card.borderClass}`}
                          >
                            <CardBody>
                              <CardTitle className={`mb-4 ${card.fontColor}`}>
                                {card.title}
                              </CardTitle>
                              <CardText className={`${card.fontColor}`}>
                                {card.description}
                              </CardText>
                            </CardBody>
                          </Card>
                        </Col>
                      </>
                  )
                })}
              </Row>
              <Row>
                <Col lg={12}>
                  <ModalTable
                      betType={betType}
                      size={size}
                      columns={columns}
                      data={data}
                  />
                </Col>
              </Row>
            </div>
            <div className="modal-footer" style={{ backgroundColor: "#f5f5f5" }}>
              <div className="row w-100">
                <div className="col-lg-6"></div>
                <div className="col-lg-6">
                  <div className="d-flex" style={{float: "right"}}>
                    {/*<div>*/}
                    {/*  <span className="input-group-text">$</span>*/}
                    {/*</div>*/}
                    {/*<div className="col-3">*/}
                    {/*  {" "}*/}
                    {/*  <input*/}
                    {/*    type="text"*/}
                    {/*    className="form-control"*/}
                    {/*    aria-label="Dollar amount (with dot and two decimal places)"*/}
                    {/*  />*/}
                    {/*</div>*/}
                    {/*<div className="me-2">*/}
                    {/*  <div*/}
                    {/*    style={{*/}
                    {/*      padding: "10px",*/}
                    {/*      backgroundColor: "#209cee",*/}
                    {/*      color: "white",*/}
                    {/*    }}*/}
                    {/*  >*/}
                    {/*    Show PIN*/}
                    {/*  </div>*/}
                    {/*</div>*/}
                    {/*<div*/}
                    {/*  className="me-2"*/}
                    {/*  style={{*/}
                    {/*    padding: "10px",*/}
                    {/*    backgroundColor: "#ffdd57",*/}
                    {/*    color: "black",*/}
                    {/*  }}*/}
                    {/*>*/}
                    {/*  Ticket has been paid*/}
                    {/*</div>*/}
                    <div
                        style={{
                          padding: "10px",
                          backgroundColor: "#ff385e",
                          color: "white",
                        }}
                        onClick={() => {
                          setIsOpen(false)
                        }}
                    >
                      Close
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </Fragment>
  )
}
